<div class="d-flex align-items-center" *ngIf="coBranded && spokeLogoUrl; else singleLogo">
  <img alt="Logo" [useSrcset]="true" [lazyLoad]="(hubLogoUrl | imagekitUrlAppender) + '?h-80,cm-pad_resize,q-100'"
    class="lr-hub-logo" />
  <span class="lr-co-branded-divider"></span>
  <img alt="{{spokeBrandName || 'Logo'}}" [useSrcset]="true" [lazyLoad]="(spokeLogoUrl | imagekitUrlAppender) + '?h-130,cm-pad_resize,q-100'"
    class="lr-spoke-logo" />
</div>
<ng-template #singleLogo>
  <img alt="Logo" [useSrcset]="true" [lazyLoad]="((headerLogo ? headerLogoUrl:logoUrl) | imagekitUrlAppender) + '?h-75,cm-pad_resize,q-100'"
    [ngClass]="class" />
</ng-template>
